export const wholeNumber = (value) => {
  if (typeof value === 'string') {
    return value.includes('.') ? parseInt(parseFloat(value).toFixed(2).replace('.', '')) : parseInt(value);
  } else if (typeof value === 'number' && value.toString().includes('.')) {
    return parseInt(value.toString().replace('.', ''));
  } else {
    return value;
  }
}

export const money = (value, currencySymbol = '$') => {
  return `${currencySymbol}${(value / 100).toFixed(2)}`;
}

export const deepClone = (obj) => {
  return JSON.parse(JSON.stringify(obj));
}

export const handlize = (str) => {
  return str.replace(/[\W_]+/g,' ').trim().replaceAll(' ', '-').toLowerCase();
}

export const getCardData = (productCard, detailName, overrides) => {
  let obj = { name: detailName };
  //
  switch (detailName) {
    case 'add':
      obj.data = {
        variantId: productCard.dataset.variantId,
        productId: productCard.dataset.productId,
        quantity: parseInt(productCard.dataset.quantity),
        price: productCard.dataset.productPrice,
        title: productCard.dataset.productTitle,
        image: productCard.img?.src,
        groupIndex: parseInt(productCard.dataset.groupIndex),
        step: productCard.dataset.step ? parseInt(productCard.dataset.step) : undefined,
        onlyForProductId: productCard.dataset.onlyForProductId !== '' ? productCard.dataset.onlyForProductId : undefined
      }
      if (productCard.dataset.afterFirstDiscount) {
        obj.data.discount = [productCard.dataset.productPrice, productCard.dataset.afterFirstDiscount];
      }
      break;

    case 'remove':
      obj.data = {
        variantId: productCard.dataset.variantId,
        quantity: 0,
        groupIndex: parseInt(productCard.dataset.groupIndex),
        step: productCard.dataset.step ? parseInt(productCard.dataset.step) : undefined,
        onlyForProductId: productCard.dataset.onlyForProductId !== '' ? productCard.dataset.onlyForProductId : undefined
      }
      break;

    case 'update':
      obj.data = {
        variantId: productCard.dataset.variantId,
        quantity: parseInt(productCard.dataset.quantity),
        groupIndex: parseInt(productCard.dataset.groupIndex),
        step: productCard.dataset.step ? parseInt(productCard.dataset.step) : undefined,
        onlyForProductId: productCard.dataset.onlyForProductId !== '' ? productCard.dataset.onlyForProductId : undefined
      }
      break;
  
    default:
      break;
  }
  //
  if (overrides) obj.data = {...obj.data, ...overrides};
  return obj;
}